// extracted by mini-css-extract-plugin
module.exports = {"row":"styles_row_2MqLPDvjOiULPhTJP7125C"};